/** What a Schedule link may open on the booking it selects. */
export type SchedulePanel = "messages";

export interface ScheduleSearch {
  /** The durable booking to select: Schedule moves to its day and opens its side panel. */
  appointment?: string;
  /** "messages": also open the booking's texts and emails (PA-7). */
  panel?: SchedulePanel;
}

const idPattern = /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;

/**
 * `/schedule?appointment=<id>&panel=messages`: how Today and Attention open one booking (PA-7).
 * Only an opaque booking id enters the URL, never a name or a phone number. Anything else is
 * dropped, so a mangled link opens the schedule as usual; a panel without a booking is ignored.
 */
export function validateScheduleSearch(search: Record<string, unknown>): ScheduleSearch {
  const appointment = search.appointment;
  if (typeof appointment !== "string" || !idPattern.test(appointment)) return {};
  return search.panel === "messages" ? { appointment, panel: "messages" } : { appointment };
}

/** The link that opens a booking's texts and emails on Schedule. */
export function scheduleMessagesSearch(appointmentId: string): ScheduleSearch {
  return { appointment: appointmentId, panel: "messages" };
}
